export const Leaderboard = () => {
    return (
        <div className="h-full w-full flex items-center justify-center">
            <p className="interactions-text text-lg">  COMING SOON!  </p>
        </div>
    )
}